import * as Yup from "yup";
import dayjs from "dayjs";

import { productLoadStatusTypes } from "../items/productSchema";

export const validationSchema = Yup.object().shape({
    createDate: Yup.lazy((val) => {

        let from = val?.from ? val.from : ""
        let to = val?.to ? val.to : ""

        let valueSchema;

        if (from !== "" || to !== "") {
            valueSchema = Yup
                .string()
                .required('Date is required')
        }

        return Yup.object().shape({
            from: valueSchema,
            to: valueSchema
        })

    })
    // dateFrom: Yup.string().nullable()
    //     .when('dateTo', {
    //         is: (dateTo) => dateTo && dateTo.trim() !== '',
    //         then: Yup.string().required('Date From is required'),
    //         otherwise: Yup.string().nullable().notRequired()
    //     })
    //     .typeError('Invalid date format'),
    // dateTo: Yup.string().nullable()
    //     .when('dateFrom', {
    //         is: (dateFrom) => dateFrom && dateFrom.trim() !== '',
    //         then: Yup.string().required('Date To is required'),
    //         otherwise: Yup.string().nullable().notRequired()
    //     })
    // filterCreateDateFrom: Yup
    //     .string()
    //     .when('customerMarking', {
    //         is: (val) => val && val.trim() !== '',
    //         then: Yup.string().required("Create From Date"),
    //         otherwise: Yup.string()
    //     })
    // .required("Required"),
    ,
    // filterCreateDateTo: Yup
    //     .string()
    //     // .required("Required")
    //     .when('filterCreateDateFrom', {
    //         is: (val) => val && val.trim() !== '',
    //         then: Yup.string().required("Create To Date"),
    //         otherwise: Yup.string().notRequired()
    //     }).typeError('Invalid date format')
})

export const initialValues = {
    // dateFrom: "",
    // dateTo: "",
    createDate: {
        from: "",
        to: ""
    },
    checkInDate: {
        from: "",
        to: ""
    },
    // filterCreateDateFrom: "", // dayjs(),
    // filterCreateDateTo: "", // dayjs(),
    customerMarking: "",
    supplierName: "",
    supplierPurchaseNumber: "",
    loadStatus: ""
}